import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQ = () => {
  const faqs = [
    {
      question: "Vad gör en sociala mediebyrå?",
      answer: "En sociala mediebyrå hjälper företag att synas, växa och bygga varumärke genom innehållsproduktion (foto, video, text), annonsering och strategi. Vi på Story Store skapar innehåll som både ser bra ut och ger mätbara resultat."
    },
    {
      question: "Varför ska vi anlita en sociala mediebyrå istället för att sköta allt själva?",
      answer: "Att driva sociala medier kräver tid, kunskap och resurser. Med oss får du ett helt team (fotograf, videograf, content creator och projektledare) istället för en enskild resurs. Vi producerar konsekvent innehåll, följer trender och optimerar annonser – så att du kan fokusera på din kärnverksamhet."
    },
    {
      question: "Hur mycket kostar det att anlita er?",
      answer: "Vi har tre paket: Närvaro, Tillväxt och Partner. Priset beror på hur mycket innehåll och strategi ni behöver. Alla paket är flexibla och kan skalas efter ert företags mål."
    },
    {
      question: "Vilka plattformar jobbar ni med?",
      answer: "Vi arbetar med de största plattformarna: Instagram, TikTok, Facebook, LinkedIn och YouTube. Valet av kanal beror på er målgrupp och era affärsmål."
    },
    {
      question: "Hur snabbt kan jag förvänta mig resultat?",
      answer: "Sociala medier är en långsiktig investering. Vissa kampanjer kan ge effekt direkt, men generellt ser man tydliga resultat efter 3–6 månader beroende på bransch, mål och budget."
    },
    {
      question: "Vad ingår i ert arbete med annonsering?",
      answer: "Vi planerar, sätter upp och optimerar betalda kampanjer på Meta (Facebook/Instagram), TikTok och LinkedIn. Det kan handla om att öka räckvidd, bygga följare, driva leads eller skapa försäljning – helt beroende på dina mål."
    },
    {
      question: "Hur ofta publicerar ni innehåll?",
      answer: "Det beror på valt paket. I vårt minsta paket ingår minst ett inlägg per vecka, i våra större paket 2–4 inlägg i veckan, kombinerat med regelbunden video och foto."
    },
    {
      question: "Kan ni hjälpa oss att hantera kommentarer och meddelanden?",
      answer: "Ja! Community management kan ingå som tillägg. Vi kan övervaka, svara och hantera dialogen på dina kanaler enligt en tydlig tonalitet och strategi."
    },
    {
      question: "Är det värt att anlita en social media-byrå?",
      answer: "Ja – för de allra flesta företag är det en investering som lönar sig. Att anlita en byrå innebär att du får tillgång till ett helt team av experter som producerar innehåll, följer trender och optimerar annonser. Det sparar tid internt, minskar risken för misstag och ger oftast snabbare och mer mätbara resultat än om man försöker sköta allt själv."
    }
  ];

  return (
    <section id="faq" className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-foreground mb-6">
            Vanliga frågor
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Här hittar du svar på de vanligaste frågorna om våra sociala medier-tjänster
          </p>
        </div>
        
        <div className="max-w-4xl mx-auto">
          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="bg-card border border-border rounded-lg px-6"
              >
                <AccordionTrigger className="text-left font-semibold text-foreground py-6 hover:no-underline">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground pb-6 pt-0">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;